export const HerculesHeaderName = {
	OriginPortalOrganisation: "Origin-Portal-Organisation"
} as const;